import React, { useEffect } from 'react';
import { List, Datagrid, TextField, FunctionField } from 'react-admin';

function FGInicioList(props: any) {
  useEffect(() => {
    document.title = 'FG Inicio - Gasco';
  }, []);

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="cantidad" label="Cantidad" />
        <FunctionField
          label="Portada"
          render={(record: any) => (
            record.portada ? (
              <img
                src={record.portada.url}
                alt="Portada FG Inicio"
                style={{ width: '120px', height: '60px', objectFit: 'cover', borderRadius: '4px' }}
              />
            ) : null
          )}
        />
        <FunctionField
          label="Descripción"
          render={(record: any) => {
            const text = record.descripcion?.[0]?.children?.[0]?.text || '';
            return <span>{text.substring(0, 70)}...</span>;
          }}
        />
      </Datagrid>
    </List>
  );
}

export default FGInicioList;
